{
"SPIRITS": 0,
"BEER": 0,
"WINE": 0,
"OTHER": 0,
"CIGARETTES": 0,
"CIGARS": 0,
"TOBACCO": 0,
"FUEL_OIL": 0,
"LUBRICATING_OIL": 0,
"MEAT": 0,
"NARCOTICS": 0,
"FIRE_ARMS": 0
}